<template lang='pug'>
.media
  SectionTitle(sectionText="媒體識讀")
  .media-content
    .media-paragraph
      p 面對資訊氾濫的網路年代，訊息傳播快速，閱聽眾每天都在接收龐大的資訊量，然而如何判斷訊息真偽，不光是現今國際社會議題，更是全球公民終生課題。然而，什麼是假訊息呢？假訊息是指意圖明確，刻意以傳統或社群媒體之新聞形式來傳播錯誤資訊，以誤導大眾並帶來政治或經濟利益，大致上可分為幾種類型：
      br
      ul.media-paragraph-ul
        li 完全造假: 有意圖的捏造: 大阪機場事件
        li 移花接木: A事件配B圖、甲地事件放到乙地、他說的變她說的、影音剪接(印尼大地震)
        li 以訛傳訛: 謠言恆久遠、一堆永流傳，包括時間錯置，拿之前之事件遭誤以為最近發生，毫無根源之文章(例某某名人說....)，或生活健康文
        li 斷章取義: 操作標題(例學姐陪吃飯)、圖片角度(例遊行多少人)、採用有利的統計數字等。
      br
      p 近年蔚為風潮的媒體識讀和媒體素養教育，包含自主思辨力，資訊分析力，跨域學習力等。簡單來說，就是以符合自己需求的方式取用、分析、評估及製造資訊的能力。
      br
      p 媒體識讀運動的關鍵應在每位閱聽人身上展現，所以平台業者雖不是新聞製造者，但是我們設計了多元的檢舉機制以利各方共同維護平台公開頁面中的內容品質。身為資訊傳播中的一個環節，希望可以減低或杜絕假訊息的散佈，提供民眾一雙重新看媒體的眼睛，好讓大家能以更獨立與更具批判力的心靈解讀內容。
  SectionTitle(sectionText="核心素養")
  .media-content
    .media-grid
        .media-item(v-for='(item, idx) in mediaList' :key='idx')
          .media-image
           div(:class='"icon-check-" + item.iconName')
          .media-text
            .media-title {{ item.title }}
            .media-subtitle {{ item.subtitle }}

  SectionTitle(sectionText="經典案例" :displayCardCounter='true' :cardIndex='slideIndex' :cardAmount='infos.length' )
  .media-gallery
    .articleCardSlider-arrows.show--bigScreens
      .articleCardSlider-left(@click='$refs.slick.prev()')
        .icon-slide-left
      .articleCardSlider-right(@click='$refs.slick.next()')
        .icon-slide-right
    Slick.media-listGallery(v-if="infos && infos.length > 0" :options='slickOptions' ref='slick' @afterChange='changeIndex')
      MediaCarouselItem(v-for="(info, idx) in infos"  :key='idx' :info="info")
</template>

<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import MediaCarouselItem from '@/components/media/media_carousel_item.vue'
import Slick from 'vue-slick';
export default {
  components: {
    SectionTitle,
    MediaCarouselItem,
    Slick
  },
  props: {
    staticData: Object
  },
  created() {
    this.getInfo()
  },
  data() {
    return {
      infos: [],
      slideIndex: 1,
      mediaList: this.staticData.mediaList,
      slickOptions: {
        slidesToShow: 1,
        swipeToSlide: true,
        variableWidth: true,
        centerMode: false,
        infinite: false,
        arrows: false,
        autoplay: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        draggable: true,
        edgeFriction: 0.30,
        swipe: true
      }
    }
  },
  methods: {
    async getInfo() {
      this.infos = []
      let route = this.$store.state.URLs.api + '/' +this.$store.state.lang + this.$store.state.routes.classicArticles
      let result = await this.$axios.get(route)
      this.infos = Object.values(result.data.content)
    },
    changeIndex() {
      this.slideIndex = this.$refs.slick.currentSlide() + 1
    },
    slide(event) {
      this.slideIndex = event.idx
    }
  }
}
</script>
<style scoped src='./media_block.vue.css'></style>